import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import _Array$isArray from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/array/is-array";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import _typeof from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.regexp.match";
var isIosCache = null; //default true

export function isNumber(val) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数

  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数

  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  } else {
    return false;
  }
}
export var parsePrice = function parsePrice(string) {
  var value = string.match(/\d+(?:\.\d+)?/g);

  if (value) {
    return value[0];
  }

  return "";
};
/**
 * 判断是否为JSON 字符串
 * @param str
 */

export function isJSON(str) {
  if (typeof str === "string") {
    try {
      var obj = JSON.parse(str);

      if (_typeof(obj) === "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}
export function getTimeZone() {
  try {
    var timezoneNum = -(new Date().getTimezoneOffset() / 60);
    var timezoneStr = timezoneNum.toString();
    var timezoneResult;

    if (timezoneNum > 9 || timezoneNum < -9) {
      if (timezoneStr.length > 2) {
        timezoneResult = timezoneStr + "00";
      } else {
        timezoneResult = "+" + timezoneStr + "00";
      }
    } else {
      var arr = timezoneStr.split("");

      if (timezoneStr.length > 1) {
        timezoneResult = arr[0] + "0" + arr[1] + "00";
      } else {
        timezoneResult = "+0" + timezoneStr + "00";
      }
    }

    return timezoneResult;
  } catch (error) {
    return "+0800";
  }
}
export function getLang() {
  return window.navigator.language || window.navigator.userLanguage || "en_US";
}
export function isIpad() {
  if (window.navigator.userAgent && window.navigator.userAgent.toLowerCase().indexOf("ipad") > -1) {
    return "y";
  } else {
    return "n";
  }
}
export function isLength(value) {
  return typeof value === "number" && value > -1 && value % 1 === 0;
}
export function isArrayLike(value) {
  return value != null && isLength(value.length);
}
export function isEmpty(value) {
  if (value === null || value === undefined) {
    return true;
  }

  if (isArrayLike(value) && typeof value === "string" || typeof value.splice === "function" || _Array$isArray(value)) {
    return !value.length;
  }

  for (var key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }

  return true;
}
export function trimAll(str) {
  return str.replace(/\s+/g, "");
}
export function isEmail(str) {
  var re = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

  if (re.test(str) !== true) {
    return false;
  } else {
    return true;
  }
}
/**
 * 换取当前的时间戳
 */

export function getNowTimeStamp() {
  return new Date().valueOf();
} //时间戳的差值

export function diffTimeStamp(now, old) {
  if (now >= old) {
    return now - old;
  } else {
    return old - now;
  }
}
export function timestampToTime(timestamp) {
  var date = new Date(timestamp.toString().length === 10 ? timestamp * 1000 : timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

  var addZero = function addZero(number) {
    return number < 10 ? "0" + number : number;
  };

  var Y = date.getFullYear() + "-";
  var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  var D = addZero(date.getDate()) + " ";
  var h = addZero(date.getHours()) + ":";
  var m = addZero(date.getMinutes()) + ":";
  var s = addZero(date.getSeconds());
  return Y + M + D + h + m + s;
}
export function timeToString(time) {
  var h = Math.floor(time / 3600) < 10 ? "0" + Math.floor(time / 3600) : Math.floor(time / 3600);
  var m = Math.floor(time / 60 % 60) < 10 ? "0" + Math.floor(time / 60 % 60) : Math.floor(time / 60 % 60);
  var s = Math.floor(time % 60) < 10 ? "0" + Math.floor(time % 60) : Math.floor(time % 60);
  return time = h + ":" + m + ":" + s;
}
export function isIos() {
  if (isIosCache !== null) {
    return isIosCache;
  } else {
    var u = window.navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    var isiOSMore = false;

    if (window.navigator.platform && window.navigator.platform === "iPhone") {
      isiOSMore = true;
    }

    console.log("isIos:", {
      isiOS: isiOS,
      isiOSMore: isiOSMore,
      navigator: window.navigator
    });
    isIosCache = isiOS || isiOSMore;
    return isIosCache;
  }
}
export function iosVersion() {
  var str = navigator.userAgent.toLowerCase();
  var ver = str.match(/cpu iphone os (.*?) like mac os/);

  if (ver) {
    return ver[1].replace(/_/g, ".");
  } else {
    return null; //不是安卓返回null;
  }
}
export function getAppVersion() {
  /**
   *  IOS 的UA无法获取到版本的字段，原生有BUG
   */
  try {
    var findName = "Hybrid";

    if (isIos()) {
      findName = "Hybird"; //钦振写的鸟人，hybrid都能拼错
    }

    var u = window.navigator.userAgent;
    var firstIndex = u.indexOf(findName);

    if (firstIndex === -1 || firstIndex === undefined) {
      //证明UA有问题:
      return "1.0.0";
    }

    var startIndex = u.indexOf("(", firstIndex);
    var endIndex = u.indexOf(")", startIndex);
    var fitlerString = u.substring(startIndex + 1, endIndex); // console.log("filterString:>>>>", fitlerString);

    return fitlerString.split(",")[0];
  } catch (error) {
    return "1.0.0";
  }
}
export function stringOccurrence(main_str, sub_str) {
  main_str += "";
  sub_str += "";

  if (sub_str.length <= 0) {
    return main_str.length + 1;
  }

  var subStr = sub_str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return (main_str.match(new RegExp(subStr, "gi")) || []).length;
}
export function getElementOffset(el) {
  var rect = el.getBoundingClientRect();
  return {
    x: rect.left + window.scrollX,
    y: rect.top + window.scrollY
  };
}